import { render } from "./ButtonBlock.vue?vue&type=template&id=280800da&scoped=true"
import script from "./ButtonBlock.vue?vue&type=script&lang=js"
export * from "./ButtonBlock.vue?vue&type=script&lang=js"

import "./ButtonBlock.vue?vue&type=style&index=0&id=280800da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280800da"]])

export default __exports__